<template>
	<div class="ModuleBottom">
		<div class="ModuleBottomWave">
			<img :src="WaveImageUrl" width="100%"/>
		</div>
		<div class="ModuleBottomMain">
			<div class="ModuleBottomMainBody">
				<div class="ModuleBottomMainBodyTop">
					<div class="ModuleBottomMainBodyTopLogo">
						<div class="ModuleBottomMainBodyTopLogoBody" @click="onToHome()">
							<img :src="LogoData" width="100%"/>
						</div>
					</div>
					<div class="ModuleBottomMainBodyTopNav">
						<div class="ModuleBottomMainBodyTopNavBody">
							<div class="ModuleBottomMainBodyTopNavBodyItem" v-for="(Item,Index) in NavData" :key="Index" @click="NavClick(Item)">
								{{Item.Title}}
							</div>
						</div>
					</div>
				</div>
				<div class="ModuleBottomMainBodyAbout">
					<div class="ModuleBottomMainBodyAboutXiJiang">
						<div class="ModuleBottomMainBodyAboutXiJiangCompany">{{CompanyData.CompanyName}}</div>
						<div class="ModuleBottomMainBodyAboutXiJiangAddress">{{CompanyData.CompanyAddress}}</div>
						<div class="ModuleBottomMainBodyAboutXiJiangContactTel">{{CompanyData.CompanyTelephone}}</div>
					</div>
					<div class="ModuleBottomMainBodyAboutMedia">
						<div class="ModuleBottomMainBodyAboutMediaItem" v-for="(Item,Index) in QRCodeData" :key="Index">
							<el-popover :width="200" placement="top">
								<template #reference>
									<div class="ModuleBottomMainBodyAboutMediaItemQRCode">
										<img :src="Item.Image?.Url" width="100%"/>
									</div>
								</template>
								<template #default>
									<img :src="Item.Image?.Url" width="100%"/>
								</template>
							</el-popover>
							<div class="ModuleBottomMainBodyAboutMediaItemTitle">{{Item.Title}}</div>
						</div>
					</div>
				</div>
				<div class="ModuleBottomMainBodyIcp">
					<div class="ModuleBottomMainBodyIcpBtn" @click="onToICP()">{{ICP}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
